/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionErrorDetails } from './PalAuthSubmissionErrorDetails';
import {
    PalAuthSubmissionErrorDetailsFromJSON,
    PalAuthSubmissionErrorDetailsFromJSONTyped,
    PalAuthSubmissionErrorDetailsToJSON,
    PalAuthSubmissionErrorDetailsToJSONTyped,
} from './PalAuthSubmissionErrorDetails';

/**
 * 
 * @export
 * @interface PalAuthSubmissionMetadata
 */
export interface PalAuthSubmissionMetadata {
    /**
     * 
     */
    remote_dashboard_id?: string;
    /**
     * 
     */
    error_details?: PalAuthSubmissionErrorDetails;
    /**
     * Verbatim payer name read off the Availity routing page (e.g. "PREMERA BLUECROSS (WA)") on a routed failure. The display value for which payer the patient was routed to. Present for both PAYOR_ROUTED_TO_DIFFERENT_PAYOR and PAYOR_ROUTED_TO_DIFFERENT_PAYOR_WITH_RPA; the error_type signals whether an automatic switch/retry is available.
     */
    changed_payer_target_raw_name?: string;
    /**
     * Normalized destination fax number used for eFax submissions.
     */
    destination_fax_number?: string;
    /**
     * Normalized fax number the eFax was sent from. Null when sent from the shared/generic exacare fax number rather than a dedicated eFax inbox number.
     */
    sender_fax_number?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionMetadata interface.
 */
export function instanceOfPalAuthSubmissionMetadata(value: object): value is PalAuthSubmissionMetadata {
    return true;
}

export function PalAuthSubmissionMetadataFromJSON(json: any): PalAuthSubmissionMetadata {
    return PalAuthSubmissionMetadataFromJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'remote_dashboard_id': json['remote_dashboard_id'] == null ? undefined : json['remote_dashboard_id'],
        'error_details': json['error_details'] == null ? undefined : PalAuthSubmissionErrorDetailsFromJSON(json['error_details']),
        'changed_payer_target_raw_name': json['changed_payer_target_raw_name'] == null ? undefined : json['changed_payer_target_raw_name'],
        'destination_fax_number': json['destination_fax_number'] == null ? undefined : json['destination_fax_number'],
        'sender_fax_number': json['sender_fax_number'] == null ? undefined : json['sender_fax_number'],
    };
}

export function PalAuthSubmissionMetadataToJSON(json: any): PalAuthSubmissionMetadata {
    return PalAuthSubmissionMetadataToJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataToJSONTyped(value?: PalAuthSubmissionMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remote_dashboard_id': value['remote_dashboard_id'],
        'error_details': PalAuthSubmissionErrorDetailsToJSON(value['error_details']),
        'changed_payer_target_raw_name': value['changed_payer_target_raw_name'],
        'destination_fax_number': value['destination_fax_number'],
        'sender_fax_number': value['sender_fax_number'],
    };
}

